module.exports = __webpack_public_path__ + "img/ff3a262.png";